import styled from '@emotion/styled'

export const StyledAssetTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td,
  th {
    padding: 12px;
  }

  th {
    background-color: var(--Transparent);
    font-weight: normal;
    text-align: left;
    vertical-align: bottom;
  }

  tbody {
    background-color: var(--White96);
  }

  td {
    border: 2px solid var(--White);
  }

  tr:first-of-type td {
    border-top: 0;
  }

  .period {
    border-left: 0;
    border-right: 0;
    width: 50%;
    text-align: left;
  }

  .return {
    border-left: 0;
    border-right: 0;
    text-align: right;
  }

  .volatility {
    border-left: 0;
    text-align: right;
  }

  .max-drawdown {
    border-right: 0;
    text-align: right;
  }

  .sharpe {
    border-right: 0;
    text-align: right;
  }

  td.period {
    border-left: 0;
    border-right: 0;
    width: 30%;
    button {
      text-decoration: underline;
      text-align: left;
      &:hover {
        text-decoration: none;
      }
    }
  }

  td.return {
    border-left: 0;
    border-right: 0;
  }

  td.volatility {
    border-left: 0;
    border-right: 0;
  }

  td.max-drawdown {
    border-left: 0;
    border-right: 0;
  }

  td.sharpe {
    border-left: 0;
    border-right: 0;
  }

  tr:last-child td {
    border-bottom: 0;
  }
`
